import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid, TextField } from '@mui/material'

const What3Words = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <TextField
        value={opsPlan?.what3Words ?? ''}
        InputLabelProps={{
          shrink: opsPlan?.what3Words ? true : false,
        }}
        onChange={(e) => {
          setOpsPlan((prev) => ({
            ...prev,
            what3Words: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        label="What3Words"
        fullWidth
        autoComplete="off"
        name="opsPlan-what3words"
      />
    </Grid>
  )
}

export default React.memo(What3Words)
